@if (accountGroup$ | async; as accountGroup) {
  <mat-expansion-panel class="context-expansion-panel" [expanded]="true">
    <mat-expansion-panel-header>
      <mat-panel-title class="context-title">
        {{ 'CONTEXT.TITLE' | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>

    @if (accountGroup.companyName) {
      <p class="context-primary-p">{{ accountGroup.companyName }}</p>
    } @else {
      <p class="context-account-deleted">{{ 'CONTEXT.ACCOUNT_DELETED' | translate }}</p>
    }

    <p *ngIf="accountGroup.address" class="context-secondary-p">
      {{ accountGroup.address }}
    </p>
    <p *ngIf="accountGroup.address2" class="context-secondary-p">
      {{ accountGroup.address2 }}
    </p>

    @if (accountGroup.workNumber) {
      <div class="phone-div">
        <p class="context-secondary-p">
          {{ 'CONTEXT.PHONE' | translate }}
        </p>
        <p *ngIf="accountGroup.workNumber" class="context-secondary-phone">{{ accountGroup.workNumber }}</p>
      </div>
    }
  </mat-expansion-panel>
}
